import { fetchApi } from '../api/digitalVault';
import { parsePagination, parsePlaylistItems } from '../utils';
// this api retrieves a playlist's metadata and the metadata of all its entries using a URI
const getPlaylistListByUri = async (uri, params, logger) => {
    const response = await fetchApi({ ...params, uri }, `playlist/list`, {}, true, logger);
    const { hasNextPage, nextPageParams } = parsePagination(response.playlist.link);
    return {
        hasNextPage,
        data: parsePlaylistItems(response),
        paginate() {
            return hasNextPage && getPlaylistListByUri(uri, nextPageParams, logger);
        },
    };
};
export default getPlaylistListByUri;
